import type { IngredientFormType } from "../../IngredientForm.types";

export type SupplierMutationPermission = "allowed" | "forbidden";

/** Only the ingredient owner (the API's `canModify`) edits the supplier list; it manages every link. */
export const getSupplierMutationPermission = (canModifyIngredient: boolean): SupplierMutationPermission =>
    canModifyIngredient ? "allowed" : "forbidden";

/** Companies that may manage a supplier link of the ingredient: its owner and the companies it is shared with. */
export const getEligibleSupplierManagers = (ingredient: Pick<IngredientFormType, "ownedBy" | "shares">): IRI[] => [
    ...new Set(
        [ingredient.ownedBy?.["@id"], ...ingredient.shares.map((share) => share.organization["@id"])].filter(
            (iri): iri is IRI => iri !== undefined,
        ),
    ),
];

/**
 * Manager of a newly added link: the selected company when it is eligible, otherwise the owner.
 * A not-yet-owned ingredient (creation) is owned by the selected company.
 */
export const resolveNewSupplierManager = (
    ingredient: Pick<IngredientFormType, "ownedBy" | "shares">,
    selectedCompanyIri: IRI,
): IRI => {
    const eligible = getEligibleSupplierManagers(ingredient);
    if (eligible.includes(selectedCompanyIri)) return selectedCompanyIri;

    return ingredient.ownedBy?.["@id"] ?? selectedCompanyIri;
};
